import React from 'react';
import Button from '../../Common/Button/Button';
import useExpertsOfMonth from '../../hooks/useExpertsOfMonth';
import { default as img } from '../../../images/Sonder_&_Tell_Logo.png';
import './IndustryExpertsNought.scss';

const IndustryExpertsNought = () => {

  const ExpertsOfMonthData = useExpertsOfMonth();

  const { allContentfulIndustryExpertsExpertOfMonth : { edges : Experts } } = ExpertsOfMonthData;

  const [ExpertsOfTheMonth] = Experts;

  const openURL = url => window.open(url, '_blank', 'noopener');

  return (
    <div className="industry-experts-nought" style={{backgroundImage: `linear-gradient(270deg, #E3F2EC 41.47%, rgba(255, 255, 255, 0) 86.59%), url(${ExpertsOfTheMonth.node.expertsHeroImage.file.url})`}}>
      <div className="industry-experts-nought-content">
        <div className="title">
          {ExpertsOfTheMonth.node.expertsName}
          {/* Featured Expert of the Month */}
        </div>
        <div className="heading">
          <img src={ExpertsOfTheMonth.node.expertsLogo.file.url} />
        </div>
        <div className="message">
          {ExpertsOfTheMonth.node.expertsDescription}
          {/* Sonder & Tell is a London-based agency specialising in brand story, creative copywriting and tone of voice. They advocate that your brand language can be as creative as design */}
        </div>
        <div className="btn-container">
          <Button 
            cls="industry-expert-meet-btn" 
            onClick={()=>openURL(`${ExpertsOfTheMonth.node.meetTheExpertsLink}`)}
            // onClick={()=>openURL('https://www.noissue.co/partners/industry-partners/sonder-tell')} 
            label="Meet the Expert" 
          />
          <Button 
            cls="industry-expert-adv-btn" 
            onClick={()=>openURL(`${ExpertsOfTheMonth.node.readTheirAdviceLink}`)} 
            // onClick={()=>openURL('https://www.noissue.co/blog/tell-your-story-how-to-perfect-the-about-us-page-of-your-website')} 
            label="Read their Advice" 
          />
        </div>
        <div className="bottom-message">
          {ExpertsOfTheMonth.node.expertsInfo}
          {/* Sonder & Tell co-founders Emily Ames, Kate Hamilton, alongside Cat Sarsfield, Marketing & Project Manager */}
        </div>
      </div>
    </div>
  )
}

export default IndustryExpertsNought ;